<template>
  <div class="request-detail" dir="rtl">
    <div class="">
      <div
        ref="form"
        v-model="valid"
      >
        <div>

          <v-row>

            <v-col cols="12" v-if="brands.length>1">
              <p>{{brand_text}}</p>

              <v-select
                :items="brands"
                label="برند"
                single-line
                outlined
                item-text="name"
                item-value="ProductTypeCategorySubGroupId"
                v-model="selected_brand"
              >
              </v-select>
            </v-col>
            <v-col cols="12" v-if="brands.filter(x=>x.ProductTypeCategorySubGroupId==selected_brand)[0].ChildInfoText!='-'">
              <v-text-field
                :label="brands.filter(x=>x.ProductTypeCategorySubGroupId==selected_brand)[0].ChildInfoText"
                single-line
                outlined
                v-model="device_model"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="توضیحات درخواست"
                v-model="customer_summary"
                outlined
                maxlength="1000"
                rows="3"
              ></v-textarea>
            </v-col>
          </v-row>

        </div>
        <div>
<!--          <v-row>-->
<!--            <v-col cols="6">-->
<!--              <v-btn color="primary enter-btn"  class="btn login-btn-gradient" v-on:click="go_to_categories(true)">-->
<!--                ثبت درخواست آنلاین-->
<!--              </v-btn>-->
<!--            </v-col>-->
<!--            <v-col cols="6">-->
<!--              <v-btn color="primary enter-btn" class="btn login-btn-gradient" v-on:click="go_to_categories(false)">-->
<!--                ثبت درخواست آفلاین-->
<!--              </v-btn>-->
<!--            </v-col>-->

<!--          </v-row>-->
          <v-row>
            <v-col cols="12">
              <v-btn color="primary enter-btn" class="btn login-btn-gradient" v-on:click="go_to_request_type">
                ثبت اطلاعات و مرحله بعد
              </v-btn>
            </v-col>
          </v-row>

        </div>
      </div>
      <v-dialog
        v-model="mapModal"
        max-width="290"
        fullscreen
        style="overflow:auto;"
      >

        <v-card class="category-modal" style="overflow: auto;height: 100%">
          <v-card-title class="headline">
            <v-col cols="6">
              ثبت درخواست آنلاین
            </v-col>
            <v-col cols="6" style="text-align: end">
              <img v-on:click="mapModal = false" src="/img/back_icon.svg" style="width: 30px;height: 30px;padding: 6px;"/>
            </v-col>
          </v-card-title>
          <v-card-text>
            <div class="mb-2">
              <treeselect
                :multiple="false"
                :load-options="load_models"
                :normalizer="normalizer_models"
                :async="true"
                searchPromptText="برای جستجو تایپ کنید..."
                noResultsText="موردی پیدا نشد."
                loadingText="در حال جستجو"
                @select="select_location"
                placeholder="جستجو مکان"
                v-model="search_location"
              />

            </div>
            <div>
              <div :style="{ height: '250px'}" id='map2'></div>
            </div>
            <v-row>
              <v-text-field
                v-model="user_address"
                placeholder="آدرس"
                outlined
              >
              </v-text-field>
            </v-row>
            <v-row>
              <v-select
                :items="online_request_types"
                label="نوع درخواست"
                single-line
                item-text="title"
                item-value="id"
                v-model="selected_request_type"
              >
              </v-select>
            </v-row>
            <v-row>
              <v-select
                :items="online_request_times"
                label="زمان درخواست"
                single-line
                item-text="title"
                item-value="id"
                v-model="selected_request_time"
              >
              </v-select>
            </v-row>

            <v-row>
              <v-col cols="sm-6">
                <v-text-field
                  v-model="user_plak"
                  placeholder="پلاک"
                  outlined
                />
              </v-col>
              <v-col cols="sm-6">
                <v-text-field
                  v-model="user_floor"
                  placeholder="واحد"
                  outlined
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>

            <v-btn
              class="cancle-btn"
              text
              @click="mapModal = false"
            >
              {{$t('cancel')}}
            </v-btn>
            <v-btn
              v-if="mapModal != ''"
              class="accept-btn "
              text
              @click="insert_online_request(),mapModal = false"
            >
              {{$t('ok')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="create_request_modal"
        max-width="290"
        fullscreen
        style="overflow:auto;"
      >

        <v-card class="category-modal" style="overflow: auto;height: 100%">
          <v-card-title class="headline">
            <v-col cols="6">
              نوع ثبت درخواست
            </v-col>
            <v-col cols="6" style="text-align: end">
                <img v-on:click="create_request_modal = false" src="/img/back_icon.svg" style="width: 30px;height: 30px;padding: 6px;"/>
            </v-col>

          </v-card-title>
          <v-card-text>
            <v-row>
             <v-col cols="12">
               <div style="padding: 5px;border-radius: 5px;border: 1px dashed grey;">
                 <strong>ثبت آنلاین و فوری درخواست</strong>
                 <br>

                 <label>توضیحات</label>
                 <br>
                 <label>با انتخاب این گزینه نزدیک ترین کارشناس در اسرع وقت به محل شما مراجعه و دستگاه شما را پذیرش یا تعمیر می نماید.</label>
                 <v-row>
                   <v-col cols="12">
                     <v-btn v-on:click="go_to_categories(true)" class="btn login-btn-gradient" color="primary enter-btn" >
                       ثبت فوری درخواست
                     </v-btn>
                   </v-col>
                 </v-row>
               </div>
             </v-col>
             <v-col cols="12">
               <div style="padding: 5px;
    border-radius: 5px;
    border: 1px dashed grey;">
                 <strong>ثبت درخواست</strong>
                 <br>

                 <label>توضیحات</label>
                 <br>
                 <label>با انتخاب این گزینه درخواست شما پس از بررسی به کارشناس مربوطه ارجاع خواهد شد و پس از هماهنگی با شما برای تعمیر یا پذیرش به محل شما مرجعه می نمایند.</label>
                 <v-row>
                   <v-col cols="12">
                     <v-btn v-on:click="go_to_categories(false)" class="btn login-btn-gradient" color="primary enter-btn" >
                       ثبت درخواست
                     </v-btn>
                   </v-col>
                 </v-row>
               </div>
             </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
  import { bus } from '../../main.js'
  import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect'

  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }
  export default {
    props: [
      'passing_data'
    ],
    components: { Treeselect },

    data () {
      return {
        brand_text: '',
        user_address: '',
        user_plak: '',
        user_floor: '',
        request_details: '',
        errors: [],
        phone_code_items: [],
        selected_phone_code: 1,
        other_number: '',
        brands: [],
        device_model: '',
        selected_brand: 0,
        device_status_items: [],
        selected_device_status: 0,
        province_items: [],
        selected_province: 0,

        city_items: [],
        selected_city: 0,

        send_from_country: false,
        create_request_modal: false,

        technician_summary: '',
        device_appearence: '',
        enable_send_from_country: false,
        customer_summary: '',
        valid: true,
        not_register: false,
        user_registered: false,
        mapModal: false,
        online_request_types: [],
        selected_request_type: 0,
        online_request_times: [],
        selected_request_time: 0,
        user_location_lat: null,
        user_location_lng: null,
        map: null,
        polygon_area: [
          [-67.13734351262877, 45.137451890638886],
        ],
        search_location: null,
        first_map: true,
        normalizer_models (node) {
          if (node.neighbourhood == null) {
            node.neighbourhood = ''
          }
          return {
            id: node.row_id,
            label: node.title + ' - ' + node.neighbourhood,
            location: node.location,
          }
        },
      }
    },
    watch: {
      selected_province: function () {
        this.get_cities()
      },
      user_location_lat: function () {
        this.get_location_address()
      }
    },
    mounted () {
      var passing_data = JSON.parse(localStorage.getItem('request_data'))
      // console.log("response", passing_data.ServiceOutBranchOnFinalize);

      this.enable_send_from_country = !passing_data.on_site_service
      if (passing_data.customer_summary != null) {
        this.customer_summary = passing_data.customer_summary
      }

      if (passing_data.other_phone_code != null) {
        this.selected_phone_code = passing_data.other_phone_code
      }
      if (passing_data.other_phone_no != null) {
        this.other_number = passing_data.other_phone_no
      }
      // this.createMap();
      this.get_reuqest_types()
      this.get_brands()
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log(position.coords.latitude, position.coords.longitude)
      })

      // this.get_provinces()
    },
    methods: {
      get_location_address () {
        var self = this
        var url = 'https://api.neshan.org/v4/reverse?lat=' + this.user_location_lat + '&lng=' + this.user_location_lng
        var params = {
          headers: {
            'Api-Key': 'service.9347b76fd7b740afa7caca50e103d6b1'
          },
        }
        this.axios.get(url, params)
          .then(response => {
            self.user_address = response.data.state + ', ' + response.data.formatted_address
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      select_location (node, instance) {
        console.log('location changedssss')

        var center_loc = [node.location.x, node.location.y]
        console.log('location changed' + center_loc)
        this.map.flyTo({
          zoom: 14,
          center: center_loc,
        })
      },
      load_models ({ action, searchQuery, callback }) {
        this.model_txt = searchQuery
        var self = this
        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options
            var url = `https://api.neshan.org/v1/search?term=${searchQuery}&lat=35.69745&lng=51.3773`
            var params = {
              headers: {
                'Api-Key': 'service.9347b76fd7b740afa7caca50e103d6b1'
              },
            }
            this.axios.get(url, params)
              .then(response => {
                self.search_entries = response.data.results
                options = response.data.items.map((item, row_id) => {
                  return { ...item, row_id }
                })
                callback(null, options)
                // this.$router.push({ path: "/post-login", params: {} });
              }).catch(e => {
              this.errors.push(e)
            })
          })
        }
      },
      get_brands () {
        var self = this
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var sub_group_id = passing_data.sub_group_id
        const send_data = {
          groupId: sub_group_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://zoodkomak.com/api/get_brands_pwa', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.brands = response.data.brands
              self.brand_text = response.data.brand_text
              self.selected_brand = self.brands[0].ProductTypeCategorySubGroupId
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },

      get_reuqest_types () {
        var self = this
        var send_data = {}
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://zoodkomak.com/api/get_online_request_options', send_data, {})
          .then(response => {
            self.online_request_times = response.data.times
            self.online_request_times.forEach(function (val) {
              val.title = 'از ' + val.from_time + ' تا ' + val.to_time
            })
            self.online_request_types = response.data.types
            self.selected_request_time = self.online_request_times[0].id
            self.selected_request_type = self.online_request_types[0].id
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },

      insert_online_request () {
        if (this.user_location_lat == null) {
          bus.$emit('show_toast', [2000, 'لطفا محل خود را روی نقشه انتخاب کنید'])
          return
        }
        if (this.user_address == null) {
          bus.$emit('show_toast', [2000, 'لطفا آدرس را وارد کنید'])
          return
        }
        var self = this

        const send_data = this.get_bind_data()
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://zoodkomak.com/api/add_request_online_pwa', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('response', response)

              // bus.$emit('show_dialog', [self.$t('requestSubmitted'), response.data.msg + '\n' + self.$t('requestCodeQ') + response.data.ReqCode])
              self.$router.push({ path: '/report-request/my-requests', params: {} })
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },

      insert_offline_request () {
        var self = this

        const send_data = this.get_bind_data()
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://zoodkomak.com/api/add_request_pwa', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('response', response)

              bus.$emit('show_dialog', [self.$t('requestSubmitted'), response.data.msg])

              self.$router.push({ path: '/report-request/my-requests', params: {} })
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_bind_data () {
        var request_id = 0

        var request_data = JSON.parse(localStorage.getItem('request_data'))
        if (request_data.PreRequestId != null) {
          request_id = request_data.PreRequestId
        }
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        // var pre_defined_array = []
        // var pre_defined = JSON.parse(request_data.pre_defined)
        var user_name = JSON.parse(localStorage.getItem('profile')).UserName
        var user_id2 = localStorage.getItem('userId2')

        const send_data = {
          UserId64: user_id2,
          UserName: user_name,
          UserMobile: localStorage.getItem('phone').replace('+98', '0'),
          postId: -1,
          time_id: this.selected_request_time,
          type_id: this.selected_request_type,
          lat: this.user_location_lat,
          lng: this.user_location_lng,
          address: this.user_address,
          plate: this.user_plak,
          floor: this.user_floor,
          user_address_id: 0,

          Id: 0, //
          ProductTypeId: request_data.cat_id, //
          CategoryId: request_data.group_id, //
          GroupId: request_data.sub_group_id, //
          SubGroupId: this.selected_brand, //
          PhoneCode: 0, //
          PhoneNo: '', //
          UserId: user_id2, //
          ModelId: 0, //
          ModelTitle: this.device_model, //
          Description: this.customer_summary, //
          RequestName: '',
        }

        console.log('salam ' + JSON.stringify(send_data))
        return send_data
      },
      go_to_categories (is_online) {
        if (this.customer_summary == '') {
          bus.$emit('show_toast', [1500, 'توضیحات درخواست را وارد کنید'])

          return false
        }
        this.create_request_modal = false

        var request_data = JSON.parse(localStorage.getItem('request_data'))
        if (is_online == true) {
          this.mapModal = true
          setTimeout(() => {
            this.createMap()
          }, 1000)
          // this.insert_online_request()
        } else {
          this.insert_offline_request()
        }
      },
      go_to_request_type () {
        if (this.customer_summary == '') {
          bus.$emit('show_toast', [1500, 'توضیحات درخواست را وارد کنید'])

          return false
        }
        this.create_request_modal = true
      },
      createMap () {
        var self = this
        // init the map
        mapboxgl.accessToken = 'pk.eyJ1Ijoib21kZXNobyIsImEiOiJjanoyaW1zNG4wMHI1M2JteTQyZXhqaTI3In0.M0GJxZnal_ysW7mxXWEZLg'
        try {
          if (this.first_map) {
            mapboxgl.setRTLTextPlugin(
              'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
              null,
              true // Lazy load the plugin
            )
            this.first_map = false
          }
        } catch (e) {
        }

        var center_loc = [51.37734351262877, 35.697451890638886]

        self.map = new mapboxgl.Map({
          container: 'map2',
          style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
          center: center_loc,
          zoom: 14 // starting zoom
        })
        self.map.resize()

        self.map.addControl(
          new mapboxgl.GeolocateControl({
            positionOptions: {
              enableHighAccuracy: true
            },
// When active the map will receive updates to the device's location as it changes.
            trackUserLocation: true,
// Draw an arrow next to the location dot to indicate which direction the device is heading.
            showUserHeading: true
          })
        )
        var centro
        self.marker = new mapboxgl.Marker({})
          .setLngLat([0, 0])
          .addTo(self.map)

        self.map.on('drag', function () {
          centro = self.map.getCenter()
          self.user_location_lat = centro.lat
          self.user_location_lng = centro.lng
          self.marker.setLngLat(centro)
        })
        self.map.on('zoom', function () {
          centro = self.map.getCenter()
          self.user_location_lat = centro.lat
          self.user_location_lng = centro.lng
          self.marker.setLngLat(centro)
        })

        self.map.on('load', function () {
          // self.show_polygon();
          self.map.resize()
          centro = self.map.getCenter()
          self.user_location_lat = centro.lat
          self.user_location_lng = centro.lng
          self.marker.setLngLat(centro)
          console.log('map loaded')
        })
      },
      updatePolygonArea () {
        var data = this.polygon_draw.getAll()
        // console.log(data);
        if (data.features.length > 0) {
          this.polygon_area = data.features[0].geometry.coordinates
          this.show_polygon()
        } else {
          this.polygon_area = []
          this.show_polygon()
        }
      },
      show_polygon () {
        this.map.addSource('maine', {
          type: 'geojson',
          data: {
            type: 'Feature',
            geometry: {
              type: 'Polygon',
              coordinates: this.polygon_area

            }
          }
        })
        this.map.addLayer({
          id: 'maine',
          type: 'fill',
          source: 'maine',
          layout: {},
          paint: {
            'fill-color': '#088',
            'fill-opacity': 0.8
          }
        })
      },

    }
  }
</script>
